import React from 'react';

const IconSearch = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2533 2.48808C4.95037 2.48808 2.19153 5.31223 2.19153 8.89873C2.19153 12.4852 4.95037 15.3094 8.2533 15.3094C11.5562 15.3094 14.3151 12.4852 14.3151 8.89873C14.3151 5.31223 11.5562 2.48808 8.2533 2.48808ZM0.191528 8.89873C0.191528 4.29964 3.75601 0.488075 8.2533 0.488075C12.7506 0.488075 16.3151 4.29964 16.3151 8.89873C16.3151 10.6045 15.8248 12.2019 14.9784 13.5367C15.0202 13.5685 15.06 13.6041 15.0974 13.6433L20.0323 18.822C20.4133 19.2219 20.3981 19.8548 19.9983 20.2358C19.5984 20.6168 18.9654 20.6016 18.5844 20.2018L13.7121 15.0887C12.2828 16.4638 10.3715 17.3094 8.2533 17.3094C3.75601 17.3094 0.191528 13.4978 0.191528 8.89873Z"
        fill="white"
      />
    </svg>
  );
};

export default IconSearch;
